import React, { useState, useEffect } from 'react'
import { Box, Stack, Text, Badge, Button, Icon } from '@/components/lib'
import { FaLightbulb, FaSyncAlt } from 'react-icons/fa'
import { InsightCarousel } from '../includes/ParticipantInsightCards'
import api from '../../api'
import utils from '../../utils/utils'
import useStore from '../../store'

export default function TrialInsightsBar ({ trialId }) {
  const { user, team, trial } = useStore()
  const [insightsData, setInsightsData] = useState(undefined)
  const [loading, setLoading] = useState(true)
  const [refreshing, setRefreshing] = useState(false)

  const hasFeature = utils.hasFeature(team, 'trialInsights')
  const hasPermission = utils.canReadTrialInsights(user, trial)
  const isEnabled = trial?.trialInsightsEnabled
  const canRefresh = utils.hasPermission(user, 'root')

  useEffect(() => {
    if (!trialId || !hasFeature || !hasPermission || !isEnabled) {
      setLoading(false)
      return
    }
    api.insights.getForTrial(trialId, (d) => {
      setInsightsData(d.insights)
      setLoading(false)
    }, () => setLoading(false))
  }, [trialId])

  function refresh () {
    setRefreshing(true)
    api.insights.refreshForTrial(trialId, (d) => {
      setInsightsData(d.insights)
      setRefreshing(false)
    }, () => setRefreshing(false))
  }

  if (loading || !hasFeature || !hasPermission || !isEnabled) return null

  const items = insightsData?.items || []
  if (items.length === 0 && !canRefresh) return null

  return (
    <Box borderWidth='1px' rounded='md' bg='bg.surface' p={3}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' mb={2}>
        <Stack direction='row' alignItems='center' gap={2}>
          <Icon as={FaLightbulb} fontSize='sm' color='yellow.400' />
          <Text fontSize='sm' fontWeight='semibold'>Insights</Text>
          <Badge colorPalette='yellow' variant='subtle'>Experimental</Badge>
        </Stack>
        {canRefresh && (
          <Button size='xs' variant='ghost' onClick={refresh} loading={refreshing}>
            <Icon as={FaSyncAlt} />
          </Button>
        )}
      </Stack>

      {items.length === 0
        ? <Text fontSize='xs' color='fg.muted'>No insights generated yet. Check back after the next daily run.</Text>
        : <InsightCarousel insights={items} />}
    </Box>
  )
}
